export const updateBookedMediaUploadedFilesComments = (items, action) => {
  const keys = ['comment', 'approval_status', 'buyer_disapproved_reason', 'disapproved_reason']
  return items.map(item => ({
    ...item,
    uploaded_files: item.uploaded_files.map(uploadedFile =>
      action.data.ids.includes(uploadedFile.id)
        ? {
            ...uploadedFile,
            ...keys.reduce((acc, key) => (action.data[key] ? { ...acc, [key]: action.data[key] } : acc), {})
          }
        : uploadedFile
    )
  }))
}

export function includesAll(arrA, arrB) {
  return arrB.every(id => arrA.includes(id))
}

export function compareInstallationReports(a, b, oldReports) {
  // Primary sort: by date_start
  const dateDiff = new Date(a.date_start) - new Date(b.date_start)
  if (dateDiff !== 0) return dateDiff

  // Secondary sort: if dates are identical, try to use the order from oldReports.
  const aOriginalIndex = oldReports.findIndex(item => item.id === a.id)
  const bOriginalIndex = oldReports.findIndex(item => item.id === b.id)

  // If at least one of them exists in the old report, follow the original ordering:
  if (aOriginalIndex !== -1 || bOriginalIndex !== -1) {
    if (aOriginalIndex !== -1 && bOriginalIndex !== -1) {
      return aOriginalIndex - bOriginalIndex
    }
    // The one that existed before gets precedence.
    return aOriginalIndex !== -1 ? -1 : 1
  }

  // Tertiary sort: compare sequential_ids
  const aIncludesB = includesAll(a.sequential_ids, b.sequential_ids)
  const bIncludesA = includesAll(b.sequential_ids, a.sequential_ids)

  if (aIncludesB && !bIncludesA) return -1
  if (bIncludesA && !aIncludesB) return 1

  // Fallback: always return 1.
  return 1
}

export const mergeBookedMediaReportProductsNextPrev = (newProducts, existingProducts) => {
  // find newly added product and product which was updated:
  const newAndUpdatedProducts = newProducts.map(newProduct => {
    const existingProduct = existingProducts.find(oldProduct => oldProduct.product_id === newProduct.product_id)

    if (existingProduct) {
      // find new quotations that don't exist in existingProduct
      const newQuotations = newProduct.quotations?.filter(
        newQuotation =>
          !existingProduct.quotations?.some(
            existingQuotation => existingQuotation.contract_id === newQuotation.contract_id
          )
      )

      // find existing quotations that were updated
      // and merge their periods with the new ones to not lose them
      const updatedExistingQuotations = existingProduct.quotations?.map(existingQuotation => {
        const newQuotation = newProduct.quotations?.find(
          newQuotation => newQuotation.contract_id === existingQuotation.contract_id
        )
        if (newQuotation) {
          return {
            ...existingQuotation,
            periods: [...(existingQuotation.periods || []), ...(newQuotation.periods || [])].sort(
              (a, b) => new Date(a.date_start) - new Date(b.date_start)
            )
          }
        }
        return existingQuotation
      })

      return {
        ...existingProduct,
        // push new booked media
        booked_media: [...existingProduct.booked_media, ...(newProduct.booked_media || [])],
        quotations: [
          // Add existing quotations that were updated
          ...(updatedExistingQuotations || []),
          // Add new quotations that don't exist in existingProduct
          ...(newQuotations || [])
        ]
      }
    } else {
      // if no existing product - just return the new one
      return newProduct
    }
  })

  // find existing products which were not updated
  const existingProductsWithoutNew = existingProducts.filter(existingProduct => {
    return !newProducts.some(newProduct => newProduct.product_id === existingProduct.product_id)
  })

  return [
    // merge new and existing updated products with not updated existing products
    ...newAndUpdatedProducts,
    ...existingProductsWithoutNew
  ]
}
